import React, { useEffect, useState } from "react";
import { Card, Skeleton } from "antd";
import { getTDData } from "../../../ApiServices/Apifun";

const Termsandcondition = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTDData()
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen py-10">
      <Card className="shadow-md">
        {loading ? (
          <>
            {/* Title Skeleton */}
            <Skeleton.Input
              active
              style={{ width: 320, height: 32 }}
              className="mb-4"
            />

            {/* Content Skeleton */}
            <Skeleton
              active
              paragraph={{ rows: 7 }}
              title={false}
            />
          </>
        ) : (
          <>
            <h1 className="text-3xl capitalize font-semibold mb-4 text-primary">
              {data?.page_title}
            </h1>

            <section className="mb-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                Introduction
              </h2>

              <div
                className="text-gray-600"
                dangerouslySetInnerHTML={{
                  __html: data?.page_description || "",
                }}
              />
            </section>
          </>
        )}
      </Card>
    </div>
  );
};

export default Termsandcondition;
